import { Injectable, Inject } from '@angular/core';
import { Feedback } from './feedback.model';
import { FeedbackApi, MobileFeedbackStatus } from '../../hickory-api';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { AuthService } from '../authentication/auth.service';
import { Observable } from 'rxjs';
import { StorageHelper } from '../storage/storage-helper';

// https://stackoverflow.com/questions/34907682/how-to-display-app-version-in-angular2
const { version: appVersion } = require('../../../../package.json');

@Injectable()
export class FeedbackService {
  constructor(private feedbackApi: FeedbackApi, @Inject(L10N_LOCALE) public locale: L10nLocale, private authService: AuthService) { }

  sendFeedback(feedback: Feedback): Observable<MobileFeedbackStatus> {
    const today = new Date();
    return this.feedbackApi.postMobileFeedback(
      {
        ApplicationName: 'Balsa',
        ApplicationVersion: appVersion,
        FeedbackText: this.appendMetadataToMessage(feedback),
        SubmitDate: today.toDateString(),
        SubmitTime: this.currentTime(today),
        DeviceUId: StorageHelper.getDeviceUId(),
      });
  }

  private currentTime(date: Date): string {
    return [date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()]
      .map(n => n.toLocaleString(this.locale.language, { minimumIntegerDigits: 2, useGrouping: false }))
      .reduce((s1, s2) => `${s1}:${s2}`);
  }

  private appendMetadataToMessage(feedback: Feedback): string {
    let message = feedback.message;
    message += (`. Type: ${feedback.type}`);

    if (feedback.url) {
      message += (` Url: ${feedback.url}`);
    }
    if (feedback.rating) {
      message += (` Rating: ${feedback.rating}`);
    }
    message += (`. Contact User: ${feedback.contact ? 'Yes' : 'No'}`);

    // append user contact info
    const user = this.authService.user.snapshot
    if (user && user.id) {
      message += (`. Contact Info: { AdminId: ${user.id};`);
      if (user.tenantId) {
        message += (` TenantId: ${user.tenantId};`);
      }
      const contact = user.contact;
      if (contact && contact.firstName && contact.lastName) {
        message += (` Name: ${contact.firstName} ${contact.lastName};`);
      }
      if (contact && contact.emails && contact.emails.length > 0) {
        message += (` Email: ${contact.emails[0].address};`);
      }
      message += ' }';
    }

    return message;
  }

}
